"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJStage = void 0;
const CGJGameScene_1 = require("./CGJGameScene");
class CGJStagePhase extends Phaser.GameObjects.Container {
    constructor(scene, x, y, w, h) {
        super(scene, x, y);
        this.background = this.scene.add.tileSprite(0, 0, Math.floor(w), Math.floor(h), null).setOrigin(0).setDepth(0);
        this.add(this.background);
        this.top = this.scene.add.tileSprite(0, 0, Math.floor(w), 32, null).setOrigin(0, 1).setDepth(0);
        this.add(this.top);
        this.right = this.scene.add.tileSprite(Math.floor(w), 0, 32, Math.floor(h), null).setOrigin(0, 0).setDepth(0);
        this.add(this.right);
        this.left = this.scene.add.tileSprite(0, 0, 32, Math.floor(h), null).setOrigin(1, 0).setDepth(0);
        this.add(this.left);
        this.bottom = this.scene.add.tileSprite(0, Math.floor(h), Math.floor(w), 32, null).setOrigin(0, 0).setDepth(0);
        this.add(this.bottom);
        this.cornerTL = this.scene.add.sprite(0, 0, null).setOrigin(1).setDepth(0);
        this.add(this.cornerTL);
        this.cornerTR = this.scene.add.sprite(Math.floor(w), 0, null).setOrigin(0, 1).setDepth(0);
        this.add(this.cornerTR);
        this.cornerBL = this.scene.add.sprite(0, Math.floor(h), null).setOrigin(1, 0).setDepth(0);
        this.add(this.cornerBL);
        this.cornerBR = this.scene.add.sprite(Math.floor(w), Math.floor(h), null).setOrigin(0).setDepth(0);
        this.add(this.cornerBR);
    }
    setAllTextures(season) {
        const tex = this.textureForSeason(season);
        this.setTexture(this.background, tex, 4);
        this.setTexture(this.top, tex, 1);
        this.setTexture(this.right, tex, 5);
        this.setTexture(this.left, tex, 3);
        this.setTexture(this.bottom, tex, 7);
        this.setTexture(this.cornerTL, tex, 0);
        this.setTexture(this.cornerTR, tex, 2);
        this.setTexture(this.cornerBL, tex, 6);
        this.setTexture(this.cornerBR, tex, 8);
    }
    setTexture(sprite, tex, idx) {
        if (!this.scene)
            return;
        if (!sprite)
            return;
        sprite.setTexture(tex);
        sprite.setFrame(idx);
    }
    textureForSeason(season) {
        switch (season) {
            case CGJGameScene_1.CGJSeason.Fall:
                return 'Grass_Fall';
            case CGJGameScene_1.CGJSeason.Spring:
                return 'Grass_Spring';
            case CGJGameScene_1.CGJSeason.Winter:
                return 'Grass_Winter';
            case CGJGameScene_1.CGJSeason.Summer:
                return 'Grass_Summer';
        }
    }
}
class CGJStage extends Phaser.GameObjects.Container {
    constructor(scene, season, x, y, w, h) {
        super(scene, x, y);
        const inset = 32;
        this.background2 = new CGJStagePhase(scene, x + inset, y + inset, w - inset * 2, h - inset * 2).setDepth(-1);
        this.scene.add.existing(this.background2);
        this.background2.setAllTextures(CGJGameScene_1.CGJSeason.Summer);
        this.background = new CGJStagePhase(scene, x + inset, y + inset, w - inset * 2, h - inset * 2).setDepth(0);
        this.scene.add.existing(this.background);
        this.background.setAllTextures(CGJGameScene_1.CGJSeason.Summer);
    }
    setSeason(season) {
        if (!this.scene)
            return;
        this.background2.setAllTextures(season);
        this.scene.add.tween({
            targets: this.background,
            duration: 500,
            alpha: 0,
            onComplete: () => {
                this.background.setAllTextures(season);
                this.background.setAlpha(1);
            }
        });
    }
}
exports.CGJStage = CGJStage;
